<template>
  <vue-perfect-scrollbar
    :settings="{ suppressScrollX: true, wheelPropagation: false }"
    class="h-100 rtl-ps-none ps scroll"
    style="height: 100%"
  >
    <div class="pa-5 relative">
      <v-app-bar
        :color="$vuetify.theme.dark ? 'dark' : 'grey lighten-5'"
        :dark="$vuetify.theme.dark"
        class=""
        fixed
        flat
      >
        <v-icon>mdi-account-circle-outline</v-icon>
        <div class="d-flex justify-space-between align-center w-full">
          <h6 class="ma-0">
            {{ PropsAccessInfo && PropsAccessInfo.loginUserName }} 회원님
          </h6>
          <slot name="userDrawerCloseButton" />
        </div>
      </v-app-bar>
    </div>

    <div class="nav pa-5 mt-10">
      <v-btn
        color="primary"
        large
        block
        outlined
        class="nav-item mb-2"
        @click="$emit('clickHome')"
      >
        <v-icon>mdi-home-outline</v-icon>
        홈
      </v-btn>

      <!-- {{ PropsAccessInfo }} -->
      <v-btn
        color="primary"
        large
        block
        outlined
        class="nav-item mb-2"
        @click="$emit('clickChangeUserInfo')"
      >
        <v-icon>mdi-shield-check-outline</v-icon>
        개인정보변경
      </v-btn>
      <v-btn
        v-if="
          meInfo && meInfo.signupPath !== 'kakao'
        "
        color="primary"
        large
        block
        outlined
        class="nav-item mb-2"
        @click="$emit('clickChangePassword')"
      >
        <v-icon>mdi-lock-open-outline</v-icon>
        비밀번호변경
      </v-btn>
    </div>
  </vue-perfect-scrollbar>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  components: {},
  name: "UserDrawer",
  props: {
    PropsAccessInfo: {
      type: [Object],
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["isDev", "meInfo"]),
  },
  mounted() {
    console.log(this.meInfo);
  },
  methods: {
    showLoginLogs() {
      this.$refs.refUserLogs.showModal();
    },
    showUserInfoEditor() {
      this.$refs.refUserInfo.showModal();
    },
  },
  
};
</script>

<style lang="scss">
header.grey.lighten-5.theme--light.v-app-bar.v-app-bar--fixed.v-sheet.v-toolbar.v-toolbar--flat {
  top: 0;
}
.nav {
  .nav-item {
    justify-content: flex-start;
    .v-icon {
      color: #000;
      margin-right: 5px;
    }
    span {
      color: #000;
    }
  }
}
</style>
